export const sentryReleaseVersion = "release-fa86f3b";
